import gql from 'graphql-tag';

import { CartEntryFragment } from './cart-entry';

/**
 * Recursion isn't currently possible here cus GQL doesn't allow cycles
 * so rn going with a max depth of 6. if we ever need more depth we can certainly
 * add it.
 *
 * https://github.com/graphql/graphql-spec/issues/91#issuecomment-197999160
 */
export const UserOrderFragment = gql`
  fragment UserOrderFragment on Order {
    _id: rbiOrderId
    rbiOrderId
    createdAt
    fireOrderIn
    status
    order {
      refund {
        refundedItems {
          # do not include 'plu' in this part of the fragment. It will cause the server to return an error due to a type mismatch between io-ts and GraphQL (map vs string)
          name
          refundAmount
          refundQuantity
          sanityId
        }
      }
    }
    delivery {
      feeCents
      tipCents
      feeDiscountCents
      serviceFeeCents
      smallCartFeeCents
      status
    }
    cart {
      ticketNumber
      storeId
      serviceMode
      posVendor
      cartVersion
      storeAddress {
        addressLine1
        addressLine2
        city
        state
        zip
      }
      cartEntries {
        ...CartEntryFragment
        children {
          ...CartEntryFragment
          children {
            ...CartEntryFragment
            children {
              ...CartEntryFragment
              children {
                ...CartEntryFragment
                children {
                  ...CartEntryFragment
                }
              }
            }
          }
        }
      }
      subTotalCents
      taxCents
      ticketNumber
      totalCents
      unavailableCartEntries {
        lineId
        sanityId
      }
      wasLoyaltyEarned
    }
  }

  ${CartEntryFragment}
`;
